/**
 * @export
 * @class AppEndPoint
 */
export namespace UserEndPoint {
    export abstract class Vessel {
        public static VESSEL_ROUTE = 'vessel/vesselRoute'; // TO BE REMOVED
        public static VESSEL_COVERED_ROUTE = 'vessel/vesselCoveredRoute';
        public static VESSEL_PREDICTED_ROUTE = 'vessel/vesselPredictedRoute';
        //AIR - Portal

    }

    export abstract class Flight {
        public static FLIGHT_CURRENT_POSITION = 'in-transit-flight';
        // public static FLIGHT_CURRENT_LOCATION = 'flight/current-location';
        public static SHIPMENT_INFO = "shipment-details";
        public static FLIGHT_COVERED_ROUTE = 'airline-routes';
    }

    export abstract class AirShipment {
        public static readonly VESSEL_SHIPMENT_LIST = "home/single-airline/all-intransit-shipments";
        public static readonly INTRANSIT_SHIPMENT_LIST = "intransit-shipments";
        public static readonly SHIPMENT_ALL_INFO = "shipment";
        // public static readonly SHIPMENT_RESULT = "tracking-list/cargo-tracking-list";
        public static readonly TRACKING_LIST_TAB = "tracking-list";
        public static readonly GLOBAL_SHIPMENT_SEARCH = "search-shipment";
     //   public static readonly SHIPMENT_SEARCH_BY_KEY = "search-by-key-reference"
        public static readonly SHIPMENT_TIMELINES_DETAILS = "time-line";

        public static readonly HARD_EXCEPTIONS_RESULT = "tracking-list/hard-exception";
    }

    export abstract class AirCommonService {
        public static readonly DOWNLOAD_USER_MANUAL = "common/document";
    }

    export abstract class AirFilters {
        public static readonly FILTERS = "filters";
        public static readonly BDP_SBUS = AirFilters.FILTERS + "/" + "sbu-descriptions";
        public static readonly CARRIER_NAMES = AirFilters.FILTERS + "/" + "carrier-names";
        public static readonly SERVICE_CODES = AirFilters.FILTERS + "/" + "service-codes";
        public static readonly BDP_REPRESENTATIVES = AirFilters.FILTERS + "/" + "bdp-representatives";
        public static readonly PORT_OF_DEPATURE = AirFilters.FILTERS + "/" + "port-of-departure";
        public static readonly DESTINATION_COUNTRY = AirFilters.FILTERS + "/" + "destination-country";
        public static readonly PORT_OF_ARRIVAL = AirFilters.FILTERS + "/" + "port-of-arrival";
        public static readonly ORIGIN_COUNTRY = AirFilters.FILTERS + "/" + "origin-country";
        public static readonly ORIGIN_DESTINATION_REGION = AirFilters.FILTERS + "/" + "origin-destination-regions";
        public static readonly PLACE_OF_RECEIPT = AirFilters.FILTERS + "/" + "place-of-receipt";
        public static readonly PLACE_OF_DELIVERY = AirFilters.FILTERS + "/" + "place-of-delivery";
        public static readonly FLIGHTS = AirFilters.FILTERS + "/" + "flights";
        public static readonly ORIG_REGION_COUNTRY = AirFilters.FILTERS + "/" + "country-region";
    }


    export abstract class AirEventManagement {

        public static readonly GET_SHIPMENTS = "event-manager/list";
        public static readonly GET_SHIPMENTS_EVENTS_HISTORY = "event-manager/history";
        public static readonly GET_SHIPMENT_EVENTS = "event-manager/get-events";
        public static readonly ADD_SHIPMENT_EVENTS = "event-manager/event";
        public static readonly GET_SHIPMENTS_FLIGHT = "master/flights";
        public static readonly GET_TIME_ZONE = "master/time-zone/iatacode";
        public static readonly GET_ALL_EVENTS = "master/event-master";
        public static readonly GET_ALL_IATA_CODES = "master/airport-master";
        public static readonly DELETE_SHIPMENT_EVENTS = "event-manager/event/delete";


    }
    export abstract class FlightEquivalency {

        public static readonly GET_FLIGHT_EQUIVALENCIES= "flight-equivalence/get-all-flight-equivalence";
        public static readonly ADD_FLIGHT_EQUIVALENCY = "flight-equivalence/create-flight-equivalence";
        public static readonly UPDATE_FLIGHT_EQUIVALENCY = "flight-equivalence/update-flight-equivalence";
        public static readonly DELETE_FLIGHT_EQUIVALENCY = "flight-equivalence/delete-flight-equivalence";
        public static readonly GET_FLIGHT_EQUIVALENCIE_BY_FLIGHT_NUMBER = "flight-equivalence/flight-number"


    }


    export abstract class PortalProfile {
        public static GET_KEY_REFERENCE_NUMBER = 'portal/profile/getKeyReferenceSettings';
        public static SET_KEY_REFERENCE_NUMBER = 'portal/profile/setKeyReferenceSettings';
        public static GET_SAVED_FILTERS = 'filters/get'; //AIR - PORTAL
        public static SET_SAVED_FILTERS = 'filters/save'; //AIR - PORTAL
        public static DELETE_FILTER = 'filters/delete';
        public static GET_ETA_THRESHOLD_FILTERS = 'user/eta';
        public static SET_ETA_THRESHOLD_FILTERS = 'user/eta'
        public static readonly FILTER_DROPDOWN = "filters/dropdown-values";
    }


    export abstract class FiltersPoints {
        public static readonly PORTS = '';
        public static readonly PERIODS = '';
        public static readonly STATUS = '';
        public static readonly CARRIER_NAMES = '';
        public static readonly DRAY_PROVIDERS = '';
        public static readonly CONTAINER_TYPES = '';
        public static readonly SHIP_FROM_LOCATIONS = '';
        public static readonly DELIVERY_LOCATIONS = '';
        public static readonly DATE_RANGES = '';
    }

    export abstract class AlertSubscription {
        public static readonly ALERT_SUBSCRIPTION = "portal/alert/subscription"
        public static readonly GET_USER_ALERTS = AlertSubscription.ALERT_SUBSCRIPTION + "/bulk";
        public static readonly DELETE_USER_ALERT = "";
        public static readonly UPDATE_USER_ALERT = "";
    }

    export abstract class AuthPoints {
        public static readonly ADD_USER = "user/addUser";
        public static readonly FORGOT_PASSWORD = "user/forgot-password";
        public static readonly GET_USER_BY_ID = "user/getUserById";
        public static readonly LOGIN_USER = "user/loginUser";
        public static readonly RESET_PASSWORD = "user/resetPassword";
        public static readonly RESET_PASSWORD_LINK = "user/resetPasswordLink";
        public static readonly UPDATE_USER = "user/updateUser";
    }

    export abstract class StaticUrls {
        public static readonly WATERMARK_IMAGE = "http://manvendravidyamandir.in/BDP.png";
        public static readonly NOTE_IMAGE = "http://manvendravidyamandir.in/BDP_note.png";
    }

    export abstract class CommonService {
        public static readonly COMPANY = "common/company";
        public static readonly BDP_REPRESENTATIVE_NAME = "common/bdpRepresentativeName";
        public static readonly CUSTOMER_SERVICE_REPRESENTATIVE = "common/customerServiceRepresentatives";
        public static readonly BDP_SBUS = "common/sbus";
        public static readonly SERVICE_CODE = "common/serviceCode";
        public static readonly METHOD_OF_TRANSPORT_CODE = "common/mots";
        public static readonly CARGO_TYPES = "common/cargoType";
        public static readonly CARRIERS = "common/carriers";
        public static readonly VESSLES = "common/vessles";
        public static readonly PLACE_OF_RECEIPT = "common/placeOfReceipt";
        public static readonly PLACE_OF_DELIVERY = "common/placeOfDelivery";
        public static readonly ALERTS_LIST = "common/alerts";
        public static readonly EVENTS_LIST = "common/events";
        public static readonly POD = "common/POD";
        public static readonly POA = "common/POA";
        public static readonly MASTER_EVENTS = "common/masterEvents";
        public static readonly COUNTRY_REGION = "common/getRegion";
        public static readonly DOWNLOAD_USER_MANUAL = "common/document";

    }

    export abstract class Shipments {
        public static readonly SHIPMENT_LIST = "shipments/shipmentList";
        //US 2851 In Transit List not showing all shipments on multi-shipment Vessel
        public static readonly VESSEL_SHIPMENT_LIST = "shipments/vesselShipmentList";
        // public static readonly SHIPMENT_SEARCH = "shipment-search"; //air - portal
        // public static readonly SHIPMENT_SEARCH_BY_KEY = "search-by-key-reference";
        // public static readonly SHIPMENT_DETAILS = "shipments/shipmentDetails" DELETED
        public static readonly SHIPMENT_INDICATORS = "shipments/shipmentTypeIndicators";
        public static readonly SHIPMENT_METRICS_SUMMARY = "shipments/shipmentMetricsSummary";
        //   public static readonly HARD_EXCEPTIONS_RESULT = "shipments/hardExceptionResult";
        public static readonly RECENTLY_VIEWED_SHIPMENTS = "shipments/recentlyViewedShipment";
        public static readonly DOWNLOAD_TRACKING_LIST = "shipments/downloadShipmentResult"; //AIR - portal


    }

    export abstract class Tracking {
        public static readonly TIMELINE_DETAILS = "tracking/timeline"; //AIR - portal
        public static readonly SCHEDULE_DETAILS = "tracking/scheduleNewType";
        public static readonly HARD_EXCEPTIONS_RESULT = "tracking-list/hard-exception";
        public static readonly ROUTE_INFO = "tracking/routeInfo";
        public static readonly LOCATION_INFO = "tracking/location";
        public static readonly EVENTS_INFO = "tracking/eventNew";
        public static readonly PORT_OF_CALL = "tracking/portOfCall";
        //  public static readonly VALIDATE_USER = "tracking/validateUser";
        //   public static readonly SHIPMENT_All_INFO = "shipment";

    }

    //REMOVE THIS
    export abstract class smartDocuments {
        public static readonly DMS_DOCUMENT = "smartDocuments/fetchDoc";
        public static readonly HAS_DOCUMENT = "smartDocuments/hasDocument";
        public static readonly CALL_DOCUMENT = "smartDocuments/callDMSServer";
        public static readonly DOCUMENT_TYPES = "smartDocuments/getDocumentList";
        public static readonly DOCUMENT_DISTRIBUTION_LIST = "smartDocuments/getDocDistributionList";

    }

    export abstract class UserPortal {
        public static readonly GET_ETA_THRESHOLD = "user/eta";
        public static readonly SET_ETA_THRESHOLD = "user/eta";
        public static readonly GET_KEY_REFERENCE_SETTINGS = "portal/profile/getKeyReferenceSettings";
        public static readonly SET_KEY_REFERENCE_SETTINGS = "user/key-reference-number";
        public static readonly GET_SAVED_FILTERS = "portal/profile/getSavedFilters";
        public static readonly SET_SAVED_FILTERS = "portal/profile/setSavedFilters";
        public static readonly IS_BDP_EMPLOYEE = "user/is-bdp-employee";
        // public static readonly GET_USER_LIST = "portal/user/getAllUsers";
        // public static readonly GET_QLIK_TOKEN = "portal/user/getQlikToken";
        // public static readonly GET_THOUGHT_SPOT_CONFIG = "portal/user/getThoughtspotConfig";
        // public static readonly GET_ALL_AIR_USERS = 'user/all-users';
        // public static readonly GET_ALL_PENDING_USERS = 'user/all-pending-users';
        public static readonly GET_ALL_AIR_USERS = 'user/exist-user';
        public static readonly GET_ALL_PENDING_USERS = 'user/pending-user';
        public static readonly GET_ALL_COMPANIES = "company/all-companies";
        public static readonly GET_USER_DETAILS = "user/details";
        public static readonly GET_COMPANY_ASSOCIATED = "user/associated-company";
        public static readonly SAVE_AIR_USER = "user/configure";
        public static readonly SET_EULA = "user/eula";
        public static readonly USER_CONFIG = "user/user-config";
        public static readonly GET_FEATURE = "user/feature";
        public static SET_USER_SAVED_COLUMN_SEQUENCE = 'user/column-sequence';
        public static GET_USER_SAVED_COLUMN_SEQUENCE = 'user/get-column-sequence';
        //   public static readonly REGISTER_AIR = "user/register";  not needed as i implmented this from ocean
    }

    export abstract class Favorite {
        // public static readonly GET_FAVORITE_WITH_DETAILS = "portal/user/getFavoriteDetails";
        //  public static readonly GET_USER_FAVORITE = "portal/profile/getFavorites";
        public static readonly SET_FAVORITE = "portal/profile/addFavorites";
        public static readonly REMOVE_FAVORITE = "portal/profile/removeFavorites";
        public static readonly UPDATE_FAVORITE_WIDGET = "portal/profile/updateFavPin";
    }

    export abstract class Alert {
        //  public static readonly GET_USER_ALERTS = "portal/alerts/getAlertsForUser";
        //   public static readonly ALERT_COUNT = "portal/alerts/getNewAlertCount";
        //     public static readonly ADD_ALERT = "portal/alerts/addAlerts";
        //     public static readonly REMOVE_ALERT = "portal/alerts/removeAlerts";
        //     public static readonly MARK_US_READ = "portal/alerts/markAsRead";
        //     public static readonly DE_NOTIFY = "portal/alerts/deNotify";
        //     public static readonly GET_ALERTS = "portal/alerts/getAlerts";
        //     public static readonly GET_ALERTS_SHIPMENT = "portal/alerts/getShipmentAlerts";
        //     public static readonly MARK_ALL_US_READ = "portal/alerts/alertTypes/markAllAsRead";
    }

    export abstract class Exception {
        public static readonly GET_EXCEPTION_STATISTICS = "exception/statistics";
        public static readonly GET_EXCEPTION_LIST = "exception/list";
        public static readonly UPDATE_EXCEPTION_STATUS = "exception/update/status";
        public static readonly DOWNLOAD_EXCEPTION_FILE = "exception/download";
        public static readonly GET_EXCEPTION_FILTER_OPTIONS = "exception/exceptionMasterFilterOptions"
    }

}

export namespace AdminEndPoint {

    export abstract class CustomerManagement {
        public static readonly DELETE_CUSTOMER = "admin/group/config/delete";
        public static readonly SAVE_UPDATE_CUSTOMER = "admin/group/config/saveOrUpdate";
        public static readonly GET_CUSTOMER_CONFIG = "admin/group/config/setup";
        public static readonly GET_CUSTOMER = "admin/group/config/list";
    }


    export abstract class MultipleEventManagement {
        public static readonly GET_VESSELS = "shipments/getVessels";
        public static readonly GET_EVENTS = "shipments/seaEvents";
        public static readonly GET_PORTS_UNLOC = "shipments/getLocations";
        public static readonly SAVE_UPDATE_SHIPMENT_EVENT = "admin/shipment/event/saveOrUpdateMultipleEvents";
        public static readonly GET_VESSEL_SHIPMENT_LIST = "shipments/getActiveShipmentDetailsForVessel"
    }

    export abstract class ScheduleManagement {
        public static readonly SAVE_UPDATE_SCHEDULE = "admin/schedule/update";
        public static readonly GET_VESSEL_CARRIER_SCAC = "admin/schedule/getScacListForVessel";
        public static readonly GET_VESSEL_VOYAGE = "admin/schedule/getVoyageListForVessel";
        // public static readonly GET_VESSEL_SCHEDULES = "admin/vessel/shipment/list";
        public static readonly GET_VESSEL_SCHEDULES = "admin/schedule/getAllDetails";
        public static readonly DELETE_VESSEL_SCHEDULES = "admin/schedule/delete";
    }

    export abstract class Shipment {
        public static readonly GET_VESSEL_SHIPMENTS = "admin/shipment/vessel/getShipments";
        public static readonly GET_SHIPMENTS_CONFIG = "admin/group/config/shipment/setup";
    }

    export abstract class VesselManagement {
        public static readonly GET_VESSEL_LIST = "admin/vessel/list";
        public static readonly GET_VESSEL_DETAILS = "admin/vessel";
        public static readonly SAVE_VESSEL = "admin/vessel/schedule/save";
        // public static readonly SAVE_UPDATE_VESSEL = "admin/vessel/";

        public static readonly GET_ALL_VESSEL_DETAILS = "VesselManagement/getVesselDetails";
        public static readonly ADD_VESSEL = "VesselManagement/addVessel";
    }

    export abstract class UserManagement {

        // AIR USER ENDPOINT :

        // 
        public static readonly GET_USERS = "admin/users";
        public static readonly GET_USER_CONFIG = "admin/user/getConfig";
        public static readonly UPDATE_USERS = "admin/updateUser";
        public static readonly USERS_FEATURE = "admin/company/feature/list";
        public static readonly USERS_COMPANIES = "admin/company/list";
        public static readonly SAVE_UPDATE_COMPANIES = "admin/company/saveOrUpdate";
        public static readonly SAVE_UPDATE_FEATURE = "admin/company/feature/saveOrUpdate";
        // public static readonly IS_BDP_EMPLOYEE = "user/is-bdp-employee";
    }

    export abstract class sourceSystemManagement {
        public static readonly GET_BDP_SOURCE_SYSTEM_IDENTIFIERS = "SourceSystem/list";
        public static readonly SAVE_BDP_SOURCE_SYSTEM_IDENTIFIERS = "SourceSystem/save";
        public static readonly DELETE_BDP_SOURCE_SYSTEM_IDENTIFIERS = "SourceSystem/delete";

    }

    export abstract class bdpRepEmailManagement {
        public static readonly GET_DEFAULT_BDP_REP_LIST = "emailManager/masterBdpRepresentativeList";
        public static readonly UPDATE_DEFAULT_BDP_REP_EMAIL = "emailManager/updateEmailForBdpRepresentative";

        //For Blank BDP Rep 
        public static readonly GET_BLANK_BDP_REP_LIST = "emailManager/defaultBdpRepresentativeList";
        public static readonly DELETE_BLANK_BDP_REP_EMAIL = "emailManager/deleteDefaultRepresentative";
        public static readonly UPDATE_BLANK_BDP_REP_EMAIL = "emailManager/addOrUpdateDefaultBdpRepresentative";
    }

    export abstract class GeoFenceManagement {
        public static readonly GET_ALL_PORTS = "getAllPorts";
        public static readonly GET_PORT_DETAILS = "getPortDetails";
        public static readonly SAVE_GEOFENCE_AREA = "saveGeofenceArea";
        public static readonly DELETE_GEOFENCE_AREA = "deleteGeofenceArea";
        public static readonly GET_GEOFENCE_PORT_LIST = "getGeoFencePortList";
    }

    export abstract class ShipmentReprocessing {
        public static readonly GET_SHIPMENTS_FOR_REPROCESSING = "shipments/getAllShipmentsForReprocessing";
        public static readonly GET_SHIPMENT_LAST_PROCESS = "shipments/getLastProcessedResponse";
        public static readonly REPROCESS_SHIPMENTS = "shipments/reprocessShipments"
    }

    export abstract class DsmShipmentReprocessing {
        public static readonly GET_DSM_SHIPMENTS_FOR_REPROCESSING = "dsmReprocessing/getDsmShipmentsForReprocessing";
        public static readonly GET_SHIPMENT_LAST_PROCESS = "dsmReprocessing/getAllLogForDsmShipment";
        public static readonly REPROCESS_DSM_SHIPMENTS = "dsmReprocessing/reprocessDsmShipments";
    }
    export abstract class ThirdParty {
        public static readonly BUIL_SHIPMENT_UPLOAD = "3p/bulkShipmentUpload";
        public static readonly GET_FILE_UPLOAD_HISTORY = "3p/getFileUploadHistory";
        public static readonly VIEW_UPLOADED_SHIPMENT = "3p/viewUploadedShipment";
        public static readonly DELETE_UPLOADED_DATA = "3p/viewData/delete";
        public static readonly SAVE_UPLOAD_DATA = "3p/viewData/saveOrUpdate";
        public static readonly DOWNLOAD_ERROR_LOG = "3p/error/download";

    }

    export abstract class Cache {
        public static readonly CACHE_COMPANY = "cache/clearCacheCompanyListForUser";
    }

    export abstract class Peta {
        public static readonly GET_PETA_SUBSCRIBE = "peta/getCompanyPetaSubscribe";
        public static readonly UPDATE_PETA_COMPANY = "peta/updateCompanyPetaSubscribe";
        public static readonly UPDATE_PETA_COMPANY_LIST = "peta/updateCompanyPetaSubscribeList";
    }

}

export namespace AirAppRoutes {

    export abstract class Auth {
        public static readonly LOGIN = "login";
        public static readonly LOGOUT = "app-logout";
        public static readonly ERROR = "error";
        public static readonly ACCESS = "access";
        public static readonly EULA = "end-user-license-agreement";
        public static readonly REGISTER = "register";
        public static readonly NOT_FOUND = "notfound";
        public static readonly RESEND_LINK = "resend-link";
        public static readonly RESET_PASSWORD = "reset-password";
        public static readonly FORGET_PASSWORD = "forget-password";
        public static readonly PASSWORD_CONFIRM = "password-confirm";
        public static readonly RESET_PASSWORD_AUTH = "reset-password-auth";




    }


    export abstract class User {
        public static readonly ROOT = "app";
        public static readonly ROOT_AIR = "air";
        public static readonly HOME = User.ROOT_AIR + "/" + "home";
        public static readonly TRACKING_LIST = User.ROOT_AIR + "/" + "tracking-list";
        public static readonly FAVORITE = User.ROOT_AIR + "/" + "favorite";
        public static readonly TRACKING_LIST_TABLE = User.ROOT_AIR + "/" + "tracking-list-table";
        public static readonly TRACKING_LIST_DETAILS_HOME = User.HOME + "/details/";
        public static readonly TRACKING_LIST_DETAILS = User.TRACKING_LIST + "/details/";
        public static readonly TRACKING_LIST_DETAILS_FAVORITE = User.ROOT_AIR + "/" + User.FAVORITE + "/details/";
        public static readonly PROFILE = User.ROOT_AIR + "/" + "profile";
        public static readonly USER_CONTROL = User.ROOT_AIR + "/" + "user-control";
        public static readonly USER_CONTROL_REDIRECT = "#" + "/" + User.ROOT + "/" + User.HOME;
        public static readonly USER_ASSIGN = User.ROOT_AIR + "/" + "user-control/assign";
        public static readonly ETA_THRESHOLD = User.ROOT_AIR + "/" + "eta-threshold";
        public static readonly RELEASE_NOTES = User.ROOT_AIR + "/" + "data-upload-download";
        public static readonly ALERTS = "alerts";
        public static readonly INTRANSIT_ALERTS = "in-transit";
        public static readonly POST_ARRIVAL_ALERTS = "post-arrival";
        public static readonly PRE_DEPARTURE_ALERTS = "pre-departure";
        public static readonly CHANGE_PASSWORD = User.PROFILE + "/" + "change-password";
        public static readonly OVERVIEW = User.PROFILE + "/" + "overview";
        public static readonly KEY_REFERENCE = User.ROOT_AIR + "/" + "key-reference";
        public static readonly NOT_ASSOCIATED = "notAssociated";
        public static readonly HELP = "help";
        public static readonly GEO_FENCE_MANAGER = "geofence-manager";
        public static readonly GEO_FENCING = "geo-fencing";
        public static readonly GEO_FENCING_ALERT = "geo-fencing-alert";
        public static readonly MAINTENANCE = "maintenance";
        public static readonly REPORTING_QLIK = 'reporting-qlik';
        public static readonly REPORTING_THOUHTSPOT = 'analytics';
        public static readonly REPORTING_DASHBOARD = 'reporting-dashboard';
        public static readonly REPORTING_SSBI = 'reporting-SSBI';
        public static readonly FLIGHT_EQUIVALENCY_MANAGER = User.ROOT_AIR + "/" + "flight-equivalency";

    }
    export abstract class UserFull {
        public static readonly ROOT = "app";
        public static readonly HOME = "home";
        public static readonly TRACKING_LIST = "tracking-list";
        public static readonly FAVORITE = "favorite";
        public static readonly TRACKING_LIST_TABLE = "tracking-list-table";
        public static readonly TRACKING_LIST_DETAILS_HOME = UserFull.HOME + "/details/";
        public static readonly TRACKING_LIST_DETAILS = UserFull.TRACKING_LIST + "/details/";
        public static readonly TRACKING_LIST_DETAILS_FAVORITE = User.FAVORITE + "/details/";
        public static readonly PROFILE = "profile";
        public static readonly USER_CONTROL = "user-control";
        public static readonly USER_ASSIGN = "user-control/assign";
        public static readonly ETA_THRESHOLD = "eta-threshold";
        public static readonly RELEASE_NOTES = "data-upload-download";
        public static readonly ALERTS = "alerts";
        public static readonly INTRANSIT_ALERTS = "in-transit";
        public static readonly POST_ARRIVAL_ALERTS = "post-arrival";
        public static readonly PRE_DEPARTURE_ALERTS = "pre-departure";
        public static readonly CHANGE_PASSWORD = "change-password";
        public static readonly OVERVIEW = "overview";
        public static readonly KEY_REFERENCE = "key-reference";
        public static readonly NOT_ASSOCIATED = "notAssociated";
        public static readonly HELP = "help";
        public static readonly GEO_FENCE_MANAGER = "geofence-manager";
        public static readonly GEO_FENCING = "geo-fencing";
        public static readonly GEO_FENCING_ALERT = "geo-fencing-alert";
        public static readonly MAINTENANCE = "maintenance";
        public static readonly REPORTING_QLIK = 'reporting-qlik';
        public static readonly REPORTING_THOUHTSPOT = 'analytics';
        public static readonly REPORTING_DASHBOARD = 'reporting-dashboard';
        public static readonly REPORTING_SSBI = 'reporting-SSBI';
        public static readonly EVENTS = "events";
        public static readonly EXCEPTION = "exception";
        public static readonly FLIGHT_EQUIVALENCY_MANAGER = "flight-equivalency";


    }

    export abstract class Manager {
        public static readonly ROOT = "app";
        public static readonly ROOT_AIR = "air";
        public static readonly USER_CONTROL = Manager.ROOT_AIR + "/" + "user-control";
        public static readonly USER_ASSIGN = "user-control/assign";
        public static readonly EVENTS = "events";
        public static readonly USER_CONTROL_MANAGEMENT = "user-control";
        public static readonly EVENTS_ROUTE = Manager.ROOT_AIR + "/" + "events";
        public static readonly EXCEPTION = "exception";
        public static readonly EXCEPTION_ROUTE = "/" + Manager.ROOT_AIR + "/" + "exception";
        public static readonly ASSIGN = "assign";
        // public static readonly EVENTS = Manager.ROOT_AIR + "/" + "events";
        public static readonly PETA_MANAGEMENT = "peta-management";
        public static readonly VESSELS = "vessels";
        public static readonly VESSEL_SCHEDULE = "vessel-schedule";
        // public static readonly EXCEPTION = Manager.ROOT_AIR + "/" + "exception";
        // public static readonly USER_CONTROL = Manager.ROOT_AIR + "/" + "user-control";
        public static readonly BUSINESS_RULE = "business-rule";
        public static readonly ALERT_SUBSCRIPTION = "alert-subscription";
        public static readonly UNLOC = "UNLOC";
        public static readonly ADD_VESSEL = "add-vessel";
        public static readonly EDIT_VESSEL = "edit-vessel";
        public static readonly PORT_MANAGEMENT = "port-management";
        public static readonly CUSTOMER_MANAGEMENT = "customer-management";
        public static readonly CARRIERS_SCAC_MANAGEMENT = "carriers-scac-management";
        public static readonly ADD_EVENT_TO_MULTIPLE_SHIPMENT = "add-event-to-multiple";
        public static readonly SHIPMENT_REPROCESSING = "shipment-reprocessing";
        public static readonly SHIPMENT_REPROCESSING_DSM = "shipment-reprocessing-dsm";
        public static readonly SOURCE_SYSTEM = "source-system";
        public static readonly BDP_REP_EMAIL_MANAGEMENT = "bdp-rep-email-management"
        public static readonly DATA_UPLOAD = "data-upload";
        public static readonly VIEW_HISTORY = "view-history";
        public static readonly VIEW_DATA = "view-data";
        public static readonly ADD_PORT = "add-port";
        public static readonly UPDATE_PORT = "update-port";
    }

    export abstract class DirectLink {
        public static readonly DIRECT_LINK_KEY = "directLink/get";
        public static readonly DIRECT_LINK = "directLink/get";
        public static readonly DIRECT_LINK_ACCESS = "directLink";
        public static readonly LINK_NOT_FOUND = "notdirectLinkfound";
        public static readonly EXTERNAL_API_TRACKING_DETAILS = "external-tracking-list/details/";
        public static readonly DIRECT_LINK_TRACKING_LIST_DETAILS = User.TRACKING_LIST + "/details/";
    }


    export abstract class ReleaseNotes {
        public static GET_RELEASE_NOTES = 'portal/user/getReleaseNotes';
        public static GET_RELEASE_NOTES_BY_ID = 'portal/user/getReleaseNotesById';
        public static UPLOAD_RELEASE_NOTES = 'portal/user/releaseNotesUpload';
    }


}

export namespace OceanAppRoutes {
    export abstract class OceanCall {
        public static readonly OCEAN_VALIDATE_USER = "portal/user/validateUser";
    }

}

export namespace UMPAppRoutes {
    export abstract class UserApi {
    public static readonly GET_USERS = "api/v1/user";
    public static readonly GET_CURRENT_USER = UserApi.GET_USERS + "/getUser";
}

}